import React, { Suspense } from 'react';
import ErrorBoundary from '../../../Molecules/Common/error/ErrorBoundary';
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/tooltip";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { safeLazy } from '../../../../safeLazy';
import RemoteFallback from './RemoteFallback_MFE_Editor';
import './A_RichTextEditor.css';

const RichTextEditorMFE = safeLazy(() => import('WYSIWYG_Editor/A_RichTextEditor'), RemoteFallback);

const A_RichTextEditor = ({
  label,
  defaultValue,
  disabled,
  onChange,
  inputMaxLength,
  id,
  required,
  removeStyle,
  height,
}) => {
  return (
    <Suspense fallback={"Loading..."}>
      <ErrorBoundary>
        <RichTextEditorMFE
          id={id}
          label={label}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={onChange}
          inputMaxLength={inputMaxLength}
          required={required}
          removeStyle={removeStyle}
          height={height}
        />
      </ErrorBoundary >
    </Suspense>
  );
};

A_RichTextEditor.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  inputMaxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
  required: PropTypes.bool,
  fieldHelperText: PropTypes.string,
  removeStyle: PropTypes.bool,
  height: PropTypes.string
};

export default A_RichTextEditor;
